import { IElementType } from "../types";

export const invalidElementType: IElementType = {
  name: "invalid_element_type",
  component: () => null,
  childrenMetadata: {},
};
